import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React from "react"
import { playerStore } from "src/store/PlayerStore"

import useTranslate from "../../../../hooks/use-translate"
import { s } from "../../../../utilities/common"
import { theme } from "../../../../utilities/theme"

export const RepeatButton = ({ focusKey }: { focusKey?: string }) => {
  const t = useTranslate()
  const repeat = playerStore((state) => state.repeat)
  const setRepeat = playerStore((state) => state.setRepeat)

  const onPress = () => {
    setRepeat(repeat === "none" ? "all" : repeat === "all" ? "single" : "none")
  }

  const { focused, ref, focusSelf } = useFocusable({
    focusKey,
    onEnterPress: onPress,
  })
  const isActive = repeat !== "none"
  const activeFocusedStroke =
    focused && isActive ? theme.palette.new.playerButton : "none"
  const activeFocusedStrokeWidth = focused && isActive ? 0.5 : 0

  return (
    <Box
      sx={{ height: s("72px"), width: s("72px") }}
      tabIndex={0}
      aria-label={`${t("player__button_repeat")}: ${repeat === "none" ? t("settings_off") : repeat === "all" ? t("media_filter__all") : 1}`}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      onMouseDown={onPress}
      ref={ref}
    >
      <svg
        width={s("72px")}
        height={s("72px")}
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="36"
          cy="36"
          r="36"
          fill={focused ? "white" : theme.palette.new.playerButton}
        />
        <path
          d="M22.0986 37.5225C21.6689 37.5225 21.3027 37.376 21 37.083C20.707 36.7803 20.5605 36.4092 20.5605 35.9697V34.4463C20.5605 33.0889 20.8633 31.917 21.4688 30.9307C22.084 29.9346 22.9482 29.1729 24.0615 28.6455C25.1846 28.1182 26.5078 27.8545 28.0312 27.8545H38.4902V24.7637C38.4902 24.4121 38.5928 24.1387 38.7979 23.9434C39.0029 23.748 39.2812 23.6504 39.6328 23.6504C39.7988 23.6504 39.9502 23.6797 40.0869 23.7383C40.2334 23.7871 40.3701 23.8555 40.4971 23.9434L46.0195 28.5723C46.293 28.8066 46.4297 29.085 46.4297 29.4072C46.4297 29.7197 46.293 29.9883 46.0195 30.2129L40.4971 34.8418C40.3701 34.9395 40.2334 35.0176 40.0869 35.0762C39.9502 35.125 39.7988 35.1494 39.6328 35.1494C39.2812 35.1494 39.0029 35.0518 38.7979 34.8564C38.5928 34.6514 38.4902 34.3682 38.4902 34.0068V30.8428H27.8262C26.5371 30.8428 25.5166 31.1992 24.7646 31.9121C24.0127 32.6152 23.6367 33.5723 23.6367 34.7832V35.9697C23.6367 36.4092 23.4854 36.7803 23.1826 37.083C22.8896 37.376 22.5283 37.5225 22.0986 37.5225ZM49.8867 36.0576C50.3262 36.0576 50.6924 36.2041 50.9854 36.4971C51.2783 36.79 51.4248 37.1514 51.4248 37.5811V39.1045C51.4248 40.4717 51.1172 41.6484 50.502 42.6348C49.8965 43.6211 49.0322 44.3828 47.9092 44.9199C46.7959 45.4473 45.4775 45.7109 43.9541 45.7109H33.4951V48.8018C33.4951 49.1533 33.3926 49.4268 33.1875 49.6221C32.9922 49.8271 32.7188 49.9297 32.3672 49.9297C32.2012 49.9297 32.0449 49.9004 31.8984 49.8418C31.752 49.7832 31.6201 49.71 31.5029 49.6221L25.9658 44.9932C25.6924 44.7686 25.5557 44.5 25.5557 44.1875C25.5654 43.8652 25.7021 43.5869 25.9658 43.3525L31.5029 38.7383C31.6201 38.6309 31.752 38.5527 31.8984 38.5039C32.0449 38.4453 32.2012 38.416 32.3672 38.416C32.7188 38.416 32.9922 38.5186 33.1875 38.7236C33.3926 38.9189 33.4951 39.1973 33.4951 39.5586V42.708H44.1738C45.4531 42.708 46.4688 42.3564 47.2207 41.6533C47.9824 40.9404 48.3633 39.9834 48.3633 38.7822V37.5811C48.3633 37.1514 48.5098 36.79 48.8027 36.4971C49.1055 36.2041 49.4668 36.0576 49.8867 36.0576Z"
          fill={
            focused && repeat === "none"
              ? theme.palette.new.playerButton
              : repeat !== "none"
                ? theme.palette.tertiary.accentYellow
                : "white"
          }
          stroke={activeFocusedStroke}
          strokeWidth={activeFocusedStrokeWidth}
          strokeLinejoin="round"
        />
        {repeat === "single" && (
          <path
            d="M33 29 L36 29 L36 39 L33 39 L33 33 L31.5 34.5 L30 32.5 Z"
            transform="translate(20, -10)"
            fill={theme.palette.tertiary.accentYellow}
            stroke={activeFocusedStroke}
            strokeWidth={activeFocusedStrokeWidth}
            strokeLinejoin="round"
          />
        )}
      </svg>
    </Box>
  )
}
